module.exports = __webpack_public_path__ + "img/icon-homepage-country-arrow-open.6944a12.svg";